export default __webpack_public_path__ + "static/media/hollywoodKlein.91d01e43.jpg";